import { lazy } from 'react';
import { Route } from 'react-router';

const UserDemographics = lazy(() => import('@/pages/users/UserDemographics'));
const UserBmi = lazy(() => import('@/pages/users/UserBmi'));

export const UserRoutes = () => (
  <>
    <Route path="/user-demographics" element={<UserDemographics />} />
    <Route path="/user-bmi" element={<UserBmi />} />
  </>
);
